<template>
  <div>            
    <div class='dataContainer' >
        <ul class="list-group">
            <li class="list-group-item list-group-item-warning" v-show='gotData' >
                <div class="row">
                    <div class="col-xs-9 col-md-3" >  
                        <span class='IndexWidth'      >#</span>
                        <span class='mobiletext'       >Banco:&nbsp;&nbsp;&nbsp;<input v-model='filteredItemsDetail' class='NameWidthHeader'>&nbsp;<span class='glyphicon glyphicon-search' ></span></span>                    
                    </div>
                    <div class="hidden-sm col-md-7" >                      
                        <span class='interest_rate'   >Tasa De Interes %</span>
                        <span class='loan_max_length' >Maximo plazo de financiamiento (Años)</span>
                        <span class='loan_initial'    >Inicial %</span>
                        <span class='send_to_email'   >Enviar a Email</span>
                        <span class='ActiveWidth'     >Activo</span>
                    </div>
                    <div class="hidden-sm col-md-2" >  
                        <span class='btnWidth mobiletext' >Borrar</span>
                        <span class='btnWidth mobiletext' >Guardar</span>
                    </div>
                </div>
            </li>
            <li class="list-group-item"  v-show='gotData'>  
                <div class="row">
                    <div class="col-xs-9 col-md-3" >  
                        <span  class='IndexWidth' ></span>
                        <span> <input class='NameWidth form-control'       type='text'     v-model='newItem.name'></span>
                    </div>
                    <div class="hidden-sm col-md-7" >                      
                        <span> <input class='interest_rate form-control'   type='text'     v-model='newItem.interest_rate'   v-on:keyup='allowDecimalOnly' @change='allowDecimalOnly'></span>                
                        <span> <input class='loan_max_length form-control' type='text'     v-model='newItem.loan_max_length' v-on:keyup='allowIntOnly'     @change='allowIntOnly'></span>   
                        <span> <input class='loan_initial form-control'    type='text'     v-model='newItem.loan_initial'    v-on:keyup='allowIntOnly'     @change='allowIntOnly'></span>   
                        <span> <input class='send_to_email form-control'   type='text'     v-model='newItem.send_to_email'></span>   
                        <span  class='ActiveWidth'><input     type="checkbox" v-model="newItem.active"></span>                    
                    </div>
                    <div class="col-xs-3 col-md-2" >  
                        <span  class='btnWidth' ></span>
                        <span  class='btnWidth' ><button class="btn btn-success glyphicon glyphicon-plus-sign glyphiconSize" @click='addRow(newItem)' ></button></span>
                    </div>
                </div>                                                     
            </li>        
            <li class="list-group-item" v-for='(itemsDetail, index) in filteredItemsDetails' v-if='index < 10' >  
                <div class="row">
                    <div class="col-xs-9 col-md-3" >  
                        <span  class='IndexWidth' >{{ index+1 }}</span>
                        <span> <input class='NameWidth form-control' type='text' v-model='itemsDetail.name'></span>
                    </div>
                    <div class="hidden-sm col-md-7" >                      
                        <span> <input class='interest_rate form-control'   type='tel' v-model='itemsDetail.interest_rate'      v-on:keyup='allowDecimalOnly' @change='allowDecimalOnly'></span>                
                        <span> <input class='loan_max_length form-control' type='tel' v-model='itemsDetail.loan_max_length'    v-on:keyup='allowIntOnly'     @change='allowIntOnly'></span>   
                        <span> <input class='loan_initial form-control'    type='tel' v-model='itemsDetail.initial_rate_year1' v-on:keyup='allowIntOnly'     @change='allowIntOnly'></span>   
                        <span> <input class='send_to_email form-control'   type='text' v-model='itemsDetail.send_to_email'></span>   
                        <span  class='ActiveWidth'><input     type="checkbox" v-model="itemsDetail.active"></span>       
                    </div>
                    <div class="col-xs-3 col-md-2" >  
                        <span  class='btnWidth detailsButton' ><button type="button" v-bind:class="itemsDetail.showDetails ? classUpArrow : classDownArrow" @click='detailsRow(itemsDetail)' ></button></span>                                                              
                        <span  class='btnWidth' ><button class="btn btn-danger glyphicon glyphicon glyphicon-remove glyphiconSize" @click='deleteRow(itemsDetail)' ></button></span>
                        <span  class='btnWidth updateButton' ><button class="btn btn-success glyphicon glyphicon-ok glyphiconSize" @click='updateRow(itemsDetail)' ></button></span>
                    </div>
                </div>    
                
                <div v-if='itemsDetail.showDetails' >
                    <hr>
                    <ul class="list-group">
                        <li class="list-group-item list-group-item-warning" v-show='gotData' >          
                            <div class="row">
                                <div class="col-xs-12 col-md-12" >  
                                    <div><span class='mobiletext' >Detalles</span></div>                
                                </div>
                            </div>
                         </li>
                         <hr>
                         <li class="list-group-item"  v-show='gotData'>  
                             <div class="row">
                                <div class="col-xs-12 col-md-12" >  
                                    <div class="input-group form-group">
                                        <span class="input-group-addon input-group-addon-general">Tasa De Interes %:</span>
                                        <input type="text" class="form-control"  v-model='itemsDetail.interest_rate' v-on:keyup='allowDecimalOnly' @change='allowDecimalOnly'>
                                    </div>
                                    <div class="input-group form-group">
                                        <span class="input-group-addon input-group-addon-general">Plazo de financiamiento (Años):</span>
                                        <input type="text" class="form-control"  v-model='itemsDetail.loan_max_length' v-on:keyup='allowIntOnly' @change='allowIntOnly'>
                                    </div>
                                    <div class="input-group form-group">
                                        <span class="input-group-addon input-group-addon-general">Inicial %:</span>
                                        <input type="text" class="form-control"  v-model='itemsDetail.initial_rate_year1'v-on:keyup='allowIntOnly' @change='allowIntOnly'>
                                    </div>
                                    <div class="input-group form-group">
                                        <span class="input-group-addon input-group-addon-general">Enviar a Email:</span>
                                        <input type="text" class="form-control"  v-model='itemsDetail.send_to_email' >
                                    </div>
                                    <div class="input-group form-group">
                                        <span class="input-group-addon input-group-addon-general">Activo:</span>
                                        <input type="checkbox" class="form-control"  v-model='itemsDetail.active' >
                                    </div>                                   
                                </div>                   
                                
                            </div>                
                            <div>             
                                <button style='width:100%;' class="btn btn-primary btn-block"  @click='updateRow(itemsDetail)' >Guardar</button>                                                                     
                            </div>
                         </li>                         
                    </ul>                    
                    <hr>
                </div>                                                                                                         
            </li>        
        </ul>
    </div>
    <Pagination v-bind:pagesInfo='pagesInfo' ></Pagination>
  </div>
</template>

<script>
import { eventBus } from '../../main';
import { PaginationMixin } from '../mixin/PaginationMixin';
import { CommonMixin } from '../mixin/CommonMixin';

export default {  
  mixins : [PaginationMixin,CommonMixin],  
  data: function () {     
    return {
        newItem: {
            name:'',
            interest_rate: 0.0,
            loan_max_length: 0.0,
            loan_initial: 0.0,
            send_to_email:'',
            active: true,
            deleted: 0,
            priority: 99
        },
        ItemsDetails: [],
        filteredItemsDetail: '',
        gotData: false,       
        classDownArrow: 'btn btn-info glyphicon glyphicon-chevron-down glyphiconSize',
        classUpArrow:   'btn btn-info glyphicon glyphicon-chevron-up glyphiconSize',
        maxItemToShow: 12,
        pagesInfo:[],            
    }
  },  
  mounted: function () {        
        this.getItemsDetails();
        this.getPaginationLinks('/admin/bankadmin/','api/getbankcount', this.maxItemToShow);
  },
  watch: { // whenever question changes, this function will run        
    $route () {                
        this.getItemsDetails();                
    }
  },
  methods: {
    updateParams : function() {
        if(this.$route.params.offset)
            this.offset = this.$route.params.offset;    
        else
            this.offset = 0;     
    },    
    getItemsDetails: function() {             
        this.updateParams();           
        var callUrl = 'api/banks/maxresult/' + this.maxItemToShow + '/offset/' +  this.offset;               

        this.$http.get(callUrl).then(response => {                                    
            this.ItemsDetails = response.body.map(obj =>{                                             
                obj.showDetails = false;
                return obj;
            });

            this.gotData = true;            
        }, response => {
           eventBus.$emit('errorMsg',response);   
        });
    },    
    detailsRow: function(itemsDetail){
        itemsDetail.showDetails = !itemsDetail.showDetails;        
    },          
    deleteRow: function({id})
    {                        
        this.$http.delete('api/banks/' + id).then(response => {                                    
            eventBus.$emit('resultMessage',response);           
            this.getItemsDetails();
        }, response => {
            eventBus.$emit('errorMsg',response);
        });
    },
    updateRow: function({id, name, send_to_email, interest_rate, loan_max_length, initial_rate_year1, active, deleted})
    {                
        var initial_rate_year2 = 0 , initial_rate_year3 = 0, initial_rate_year4 = 0, initial_rate_year5 = 0, initial_rate_year6 = 0, initial_rate_year7 = 0, initial_rate_year8 = 0, initial_rate_year9 = 0;
    
        if(loan_max_length >= 1) initial_rate_year1 = initial_rate_year1;                    
        if(loan_max_length >= 2) initial_rate_year2 = initial_rate_year1;            
        if(loan_max_length >= 3) initial_rate_year3 = initial_rate_year1;
        if(loan_max_length >= 4) initial_rate_year4 = initial_rate_year1;
        if(loan_max_length >= 5) initial_rate_year5 = initial_rate_year1;
        if(loan_max_length >= 6) initial_rate_year6 = initial_rate_year1;
        if(loan_max_length >= 7) initial_rate_year7 = initial_rate_year1;
        if(loan_max_length >= 8) initial_rate_year8 = initial_rate_year1;        
        if(loan_max_length >= 9) initial_rate_year9 = initial_rate_year1;

        active = active ? 1 : 0;      
          
        this.$http.put('api/banks/' + id, {name, send_to_email, interest_rate, initial_rate_year1, initial_rate_year2, initial_rate_year3, initial_rate_year4, initial_rate_year5, initial_rate_year6, initial_rate_year7, initial_rate_year8, initial_rate_year9, active} ).then(response => {                        
            eventBus.$emit('resultMessage',response); 
            this.getItemsDetails();                                
        }, response => {            
            eventBus.$emit('errorMsg',response);    
        });
    },
    addRow: function({name, send_to_email, interest_rate, loan_max_length, loan_initial, active, deleted}){
                
        var initial_rate_year1 = 0,initial_rate_year2 = 0 , initial_rate_year3 = 0, initial_rate_year4 = 0, initial_rate_year5 = 0, initial_rate_year6 = 0, initial_rate_year7 = 0, initial_rate_year8 = 0, initial_rate_year9 = 0;
    
        if(loan_max_length >= 1) initial_rate_year1 = loan_initial;                    
        if(loan_max_length >= 2) initial_rate_year2 = loan_initial;            
        if(loan_max_length >= 3) initial_rate_year3 = loan_initial;
        if(loan_max_length >= 4) initial_rate_year4 = loan_initial;
        if(loan_max_length >= 5) initial_rate_year5 = loan_initial;
        if(loan_max_length >= 6) initial_rate_year6 = loan_initial;
        if(loan_max_length >= 7) initial_rate_year7 = loan_initial;
        if(loan_max_length >= 8) initial_rate_year8 = loan_initial;        
        if(loan_max_length >= 9) initial_rate_year9 = loan_initial;

        active = active ? 1 : 0;        
        this.$http.post('api/banks/', {name, send_to_email, interest_rate, initial_rate_year1, initial_rate_year2, initial_rate_year3, initial_rate_year4, initial_rate_year5, initial_rate_year6, initial_rate_year7, initial_rate_year8, initial_rate_year9, active} ).then(response => {                        
            eventBus.$emit('resultMessage',response);         
            this.getItemsDetails();          
        }, response => {            
            eventBus.$emit('errorMsg',response);          
        });
    },   
  },
  filters: {
     
  },
  computed: {
    filteredItemsDetails: function() {        
        return this.ItemsDetails.filter((element) => {               
            return element.name.toLowerCase().match(this.filteredItemsDetail.toLowerCase());
        });
    }      
  }
}
</script>

<style scoped>

   .dataContainer{
       width:920px;
       margin-left: 50px;       
   }

   .IndexWidth {
        display:inline-block;
        width:30px;
        padding-left: 10px;
   }
   .NameWidth {
        display:inline-block;
        width:190px;
   }

   .interest_rate{
        display:inline-block;
        width:70px;
        margin-left: 20px;
        text-align: right;
   }
   
   .loan_initial {
        display:inline-block;
        width:60px;
        margin-left: 20px;
        text-align: right;
   }

   .loan_max_length {
        display:inline-block;
        width:110px;
        margin-left: 20px;
        text-align: right;
   }

   .send_to_email {
        display:inline-block;
        width:110px;
        margin-left: 20px;
        text-align: right;
   }

   .ActiveWidth {
        display:inline-block;
        width:50px;
        margin-left: 20px;
        text-align: center;
   }

   .btnWidth{
        width:50px;
        margin-left: 10px;  
        display:inline-block;      
   }

   .glyphiconSize{
       font-size: 1.4em;
   }

    .detailsButton {
        display: none;
    }
    
    .updateButton {
        display: inline-block;
    }    


    @media screen and (max-width: 981px) {      

       .IndexWidth {
            font-size: 3em;        
            margin-right: 20px;
            padding-left: 10px;
        }

        .NameWidthHeader {
            display:inline-block;
            width:50%;
            font-size: 1em;
        }   

        .mobiletext {
            font-size: 3em;
        }   

        .NameWidth {
            display:inline-block;
            width:90%;
        }

       .dataContainer{
           width:91%;
       }

        input {        
            position:relative;
            width:100%;
            height:75px;
            font-size: 2.4em;            
        }

        button {                    
            position:relative;
            width:80px;
            height:80px;
            font-size: 2.5em;                        
        }

        .input-group-addon {                    
            font-weight: 200;
            font-size: 2.8em;                    
        }
        
       .btnWidth{
            width:38%;
            margin-left: 10px;  
            display:inline-block;      
        }

        .glyphiconSize{
            font-size: 2em;
        }    

        .detailsButton {
            display: inline-block;
        }

        .updateButton {
            display: none;
        }
   }

   @media screen and (min-width: 981px) {  
        .col-md-2 {
            padding-left: 0px;
            padding-right: 0px;
        }

        .col-md-3 {
            padding-left: 0px;
            padding-right: 0px;
        }

        .col-md-7 {
            padding-left: 0px;
            padding-right: 0px;
        }
   }


</style>



// WEBPACK FOOTER //
// BankAdmin.vue?8b0c7320